import React from 'react';
import moment from 'moment';
import { convertDoubleToStringPTBR } from '../../../../utils/ConverterUtils';

const DrePrintableReport = ({
    reportData,
    reportPeriod,
    selectedBranch,
    totalRevenue,
    totalExpenses,
    grossProfit,
    ebitda,
    netResult,
    getRevenuePercent,
    getMarginPercent,
    getValueClass
}) => {
    const generatedAt = moment().format('DD/MM/YYYY HH:mm');
    const branchLabel = selectedBranch
        ? (selectedBranch.name || selectedBranch.description)
        : 'Todas as filiais';

    const renderGroup = (group) => (
        <React.Fragment key={group.groupName}>
            <tr className="dre-print-group-row">
                <td>{group.groupName}</td>
                <td className="text-center">-</td>
                <td className="text-end">{getRevenuePercent(group.totalValue || 0)}</td>
                <td className="text-end">{convertDoubleToStringPTBR(group.totalValue || 0)}</td>
            </tr>
            {group.items?.map((item, index) => (
                <tr key={`${group.groupName}-${index}`}>
                    <td className="dre-print-subcategory">{item.categoryName || '-'}</td>
                    <td className="text-center">{item.itemCount || 0} item(s)</td>
                    <td className="text-end">{getRevenuePercent(item.netValue || 0)}</td>
                    <td className={`text-end ${getValueClass(item.netValue)}`}>
                        {convertDoubleToStringPTBR(item.netValue || 0)}
                    </td>
                </tr>
            ))}
        </React.Fragment>
    );

    if (!reportData) {
        return null;
    }

    return (
        <article className="dre-print-report">
            <header className="dre-print-header">
                <div>
                    <span className="dre-print-kicker">Relatório financeiro</span>
                    <h1>Demonstrativo de Resultado do Exercício</h1>
                    <p>
                        {moment(reportPeriod.startDate).format('DD/MM/YYYY')} - {moment(reportPeriod.endDate).format('DD/MM/YYYY')} · {branchLabel}
                    </p>
                </div>
                <div className="dre-print-generated">
                    <span>Gerado em</span>
                    <strong>{generatedAt}</strong>
                </div>
            </header>

            <section className="dre-print-summary">
                <div>
                    <span>Receita Total</span>
                    <strong className="text-success">{convertDoubleToStringPTBR(totalRevenue)}</strong>
                    <small>Base do período</small>
                </div>
                <div>
                    <span>Despesas</span>
                    <strong className="text-danger">{convertDoubleToStringPTBR(Math.abs(totalExpenses))}</strong>
                    <small>{getRevenuePercent(Math.abs(totalExpenses))}</small>
                </div>
                <div>
                    <span>EBITDA</span>
                    <strong className={getValueClass(ebitda)}>{convertDoubleToStringPTBR(ebitda)}</strong>
                    <small>{getMarginPercent(ebitda)}</small>
                </div>
                <div>
                    <span>Resultado Líquido</span>
                    <strong className={getValueClass(netResult)}>{convertDoubleToStringPTBR(netResult)}</strong>
                    <small>{getMarginPercent(netResult)}</small>
                </div>
            </section>

            <table className="dre-print-table">
                <thead>
                    <tr>
                        <th>Categoria</th>
                        <th className="text-center">Qtd. Itens</th>
                        <th className="text-end">% Receita</th>
                        <th className="text-end">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    {reportData.groups?.map(renderGroup)}

                    <tr className="dre-print-indicator-row">
                        <td colSpan="4">Indicadores Financeiros</td>
                    </tr>
                    <tr className="dre-print-total-row">
                        <td>Total de Receitas</td>
                        <td className="text-center">-</td>
                        <td className="text-end">{getRevenuePercent(totalRevenue)}</td>
                        <td className="text-end text-success">{convertDoubleToStringPTBR(totalRevenue)}</td>
                    </tr>
                    <tr className="dre-print-total-row">
                        <td>Lucro Bruto</td>
                        <td className="text-center">-</td>
                        <td className="text-end">{getMarginPercent(grossProfit)}</td>
                        <td className={`text-end ${getValueClass(grossProfit)}`}>{convertDoubleToStringPTBR(grossProfit)}</td>
                    </tr>
                    <tr className="dre-print-total-row">
                        <td>EBITDA</td>
                        <td className="text-center">-</td>
                        <td className="text-end">{getMarginPercent(ebitda)}</td>
                        <td className={`text-end ${getValueClass(ebitda)}`}>{convertDoubleToStringPTBR(ebitda)}</td>
                    </tr>
                    <tr className="dre-print-total-row">
                        <td>Total de Despesas</td>
                        <td className="text-center">-</td>
                        <td className="text-end">{getRevenuePercent(Math.abs(totalExpenses))}</td>
                        <td className="text-end text-danger">{convertDoubleToStringPTBR(Math.abs(totalExpenses))}</td>
                    </tr>
                    <tr className={`dre-print-net-row ${netResult >= 0 ? 'dre-print-net-row--positive' : 'dre-print-net-row--negative'}`}>
                        <td>Resultado Líquido</td>
                        <td className="text-center">-</td>
                        <td className="text-end">{getMarginPercent(netResult)}</td>
                        <td className={`text-end ${getValueClass(netResult)}`}>{convertDoubleToStringPTBR(netResult)}</td>
                    </tr>
                </tbody>
            </table>
        </article>
    );
};

export default DrePrintableReport;
